import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'
import InfoAccordion from '../InfoAccordion/index'
import './changePassword.scss'

@observer
class ChangePassword extends Component {
    constructor(props) {
        super(props)
        this.state = { newPassword: '', confirmPassword: '', errorMsg: '' }
    }

    onBlur = (field) => {
        this.setState({ [field.name]: field.value })
    }

    submitNew = async () => {
        const { store, history } = this.props
        const { csrf } = store
        const { newPassword, confirmPassword } = this.state
        const tryReset = await fetch('/api/user/dopassswordupdate', {
            method: 'post',
            withCredentials: true,
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json; charset=UTF-8',
            }),
            body: JSON.stringify({
                password: newPassword,
                confirmPassword,
                csrf,
            }),
        })
        const { status } = tryReset
        if (status === 200) {
            history.push('/')
        } else {
            const response = await tryReset.json()
            this.setState({ errorMsg: response.message })
        }
    }

    onSubmit = () => {
        this.submitNew()
    }

    render() {
        const { errorMsg } = this.state
        return (
            <div id="changePassword">
                <div className="panel">
                    <h2 className="title">{i18n.t('change_password')}</h2>
                    <div className="field-wrapper">
                        <div className="errorMsg" dangerouslySetInnerHTML={{ __html: errorMsg }} />
                        <Input
                            type="password"
                            name="newPassword"
                            label={`${i18n.t('resetPassword_newPassword', 'New password')}:`}
                            onBlur={this.onBlur}
                        />
                        <Input
                            type="password"
                            name="confirmPassword"
                            label={`${i18n.t('resetPassword_confirmPassword', 'Confirm new password')}:`}
                            onBlur={this.onBlur}
                        />
                    </div>
                    <InfoAccordion
                        title={`${i18n.t('reset_password_msg_new_pwd', 'New password should include:')}`}
                        hideChevron
                        show
                    >
                        <ul>
                            <li>
                                {i18n.t('reset_password_msg_pwd_req_1', '- At least eight characters')}
                            </li>
                            <li>
                                {i18n.t('reset_password_msg_pwd_req_2', '- At least one uppercase')}
                            </li>
                            <li>
                                {i18n.t('reset_password_msg_pwd_req_3', '- At least one number')}
                            </li>
                        </ul>
                    </InfoAccordion>
                    <Button
                        cssClass="uc-button primary regular"
                        onClick={this.onSubmit}
                        label={i18n.t('submit', 'Submit')}
                    />
                </div>
            </div>
        )
    }
}

export default ChangePassword
